var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen max-w-screen md:flex md:flex-col items-center",attrs:{"id":"app"}},[_c('TheHeader',{ref:"header",attrs:{"ismember":_vm.isLoggedIn}}),_c('router-view',{attrs:{"ismember":_vm.isLoggedIn}}),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }